<template>
  <div class="articleList">
    <a-list
    itemLayout="vertical"
    size="large"
    :dataSource="articleList">
      <a-list-item slot="renderItem" slot-scope="item" key="item.title">
        <template slot="actions">
          <span>
            <a-icon type="fire" style="margin-right: 5px" />
            {{item.traffic}}
          </span>
          <span>
            <a-icon type="heart" style="margin-right: 5px" />
            {{item.love}}
          </span>
          <span style="color: #aaa;">{{item.createBy}}</span>
        </template>
        <img v-if="item.pictureUrl" slot="extra" alt="logo" :src="item.pictureUrl" />
        <!-- <div slot="extra" :class="{width: '160px', 'background-image': `url(${item.pictureUrl})`}"></div> -->
        <a-list-item-meta
          :description="item.summary"
        >
          <a @click="viewArticle(item.id)" slot="title">{{item.title}}</a>
          <!-- <a-avatar slot="avatar" :src="item.avatar" /> -->
        </a-list-item-meta>
        
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
// import { Button, Tag, Icon, List} from 'ant-design-vue';

export default {
  props: [
    'articleList'
  ],
  components: {
    // 'a-button': Button,
    // 'a-tag': Tag,
    // 'a-icon': Icon,
    // 'a-list': List,
    // 'a-list-item': List.Item,
    // 'a-list-item-meta': List.Item.Meta
  },
  data() {
    return {
      actions: [
        { type: 'like-o', text: '156' },
        { type: 'message', text: '2' },
      ]
    }
  },
  methods: {
    viewArticle(id) {
      this.$router.push(`/article/${id}`)
    }
  }
}
</script>

<style scoped>
.articleList {
  margin-top: 3rem;
}
.ant-empty-description {
  text-align: center;
}
.ant-list-item-meta-title>a {
  color: #1890ff;
}
.ant-list-item-extra img {
  width: 160px;
  height: 100px;
}
@media screen and (max-width: 576px) {
  .ant-list-item-extra img {
    width: 100%;
    height: auto;
  }
}
</style>



